window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    window.addEventListener('scroll', e => {
        const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
        document.querySelector('.back-to-top-link').style.display = scrollTop > 1800 ? 'block' : 'none';
    });
}

function scrollToElement(element, behavior = 'smooth') {

    const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    const finalOffset = element.getBoundingClientRect().top + scrollTop;

    window.scrollTo({
        top: finalOffset,
        behavior
    });
}